define('modules/home/main/views/get.more.history.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "modules/base/views/get.more.view",
    "text!modules/home/main/templates/get.more.history.template.html"
], function(
    Prospector,
    $,_,Backbone,Marionette, GetMoreView, Template
){
    var GetMoreHistoryView = GetMoreView.extend({
        template: _.template(Template),
        className: 'homeActivity animated slideInUp',
        debugName: 'Get More History View'
    });
    return GetMoreHistoryView;
});

